var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.id
    ? _c("gg-modal", {
        attrs: {
          "is-active": _vm.dialog
        },
        on: {
          close: _vm.close
        },
        scopedSlots: _vm._u(
          [
            {
              key: "toolbar",
              fn: function fn() {
                return [_vm._v(_vm._s(_vm.caption) + " Request")]
              },
              proxy: true
            },
            {
              key: "body",
              fn: function fn() {
                return [
                  _c("p", [
                    _vm._v(
                      " Are you sure you want to " +
                        _vm._s(_vm.actionText) +
                        " “" +
                        _vm._s(_vm.requestData.email) +
                        "”? "
                    )
                  ])
                ]
              },
              proxy: true
            },
            {
              key: "actions",
              fn: function fn() {
                return [
                  _c(
                    "gg-btn",
                    {
                      attrs: {
                        secondary: ""
                      },
                      on: {
                        click: _vm.close
                      }
                    },
                    [
                      _vm._v(" Cancel "),
                      _c(
                        "span",
                        {
                          staticClass: "visually-hidden text-lowercase"
                        },
                        [_vm._v("button")]
                      )
                    ]
                  ),
                  _c(
                    "gg-btn",
                    {
                      attrs: {
                        loading: _vm.loading
                      },
                      on: {
                        click: _vm.pendingAction
                      }
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.caption) + " "),
                      _c(
                        "span",
                        {
                          staticClass: "visually-hidden text-lowercase"
                        },
                        [_vm._v("button")]
                      )
                    ]
                  )
                ]
              },
              proxy: true
            }
          ],
          null,
          false,
          1870257685
        )
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }